import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import classNames from 'classnames';

import {
    Paragraph,
    Colours,
    Sizes,
    ProviderDetails,
    ANALYTICS_KEY,
    ANALYTICS_ATTRIBUTE_NAME,
} from '@ratehub/base-ui';
import RATEHUB_BROKERAGE_IDS from '../definitions/RatehubBrokerageIDs';


function MortgageSingleRateCard({
    rate,
    ...otherProps
}) {
    return (
        <Container
            ref={self => self && (self[ANALYTICS_KEY] = rate)}
            className={classNames({ [ANALYTICS_ATTRIBUTE_NAME]: !!rate })}
            {...otherProps}
        >
            <div className="rateInformation">
                <Paragraph
                    className="rate"
                    message={(
                        <FormattedNumber
                            value={`${rate?.value / 100}`}
                            format="percent2"
                        />
                    )}
                    weight="medium"
                />

                <Paragraph
                    className="termType"
                    message={(
                        <FormattedMessage
                            id="mtg-calculators.Refinance.termTypeLabel"
                            defaultMessage="{term} {type}"
                            values={{
                                term: `${rate?.term / 12}-Year`,
                                type: `${rate?.type}`,
                            }}
                        />
                    )}
                    weight="medium"
                />
            </div>

            <ProviderDetails
                providerName={rate?.provider?.name}
                isRatehubCompany={Object.values(RATEHUB_BROKERAGE_IDS).includes(rate?.provider?.id)}
                providerIcon={rate?.provider?.logo}
                ratingPercent={(rate?.provider?.rating ?? 0)*20}
                reviewCount={rate?.provider?.reviews}
                className="providerData"
            />
        </Container>
    );
}

MortgageSingleRateCard.propTypes = {
    rate: PropTypes.object.isRequired,
};

const Container = styled.div`
    display: flex;
    align-items: center;

    margin-bottom: ${Sizes.SPACING.HALF};
    padding: ${Sizes.SPACING.TWO} ${Sizes.SPACING.THREE};

    border: 1px solid ${Colours.STONE};
    border-radius: 3px;

    .checkbox {
        max-width: ${Sizes.SPACING.TWO};
        margin-right: ${Sizes.SPACING.THREE};

        input {
            border-radius: 50%;
        }
    }

    .rateInformation {
        display: flex;
        flex-direction: column;
        flex: 1;

        .rate,
        .termType {
            color: ${Colours.BLUEBERRY_DARK};
        }

        .rate {
            font-size: ${Sizes.FONTS['XL']};
            margin: 0;
        }

        .termType {
            font-size: ${Sizes.FONTS.XS};
            margin: 0;
        }
    }

    .providerData {
        flex: 1;

        display: flex;
        align-items: center;

        margin-left: auto;
    }
`;

export default observer(MortgageSingleRateCard);
